import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Passport {
  id: string,
  customerNumber?: string,
  userFlow: string  
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  
  constructor(public httpClient: HttpClient) {}

  getLoginUrl(): Observable<any> {
    //return this.httpClient.get<any>(`${this.apiUrl}/login/url`);
    return this.httpClient.get<any>('/ocmapi/login/url');
  }

  getToken(data: Passport): Observable<any> {
    if (environment.securityOff) {
      return EMPTY;
    }
    return this.httpClient.post('/ocmapi/passport', data);
    
  }
}
